import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTrans from './en-US/translation.json';
import zhTrans from './zh-CN/translation.json';
import zhTWTrans from './zh-TW/translation.json';
import jaTrans from './ja-JP/translation.json';
import koTrans from './ko-KR/translation.json';

export const resources = {
  'en-US': {
    translation: enTrans,
    locale: 'en',
  },
  'zh-CN': {
    translation: zhTrans,
    locale: 'zh',
  },
  'zh-TW': {
    translation: zhTWTrans,
    locale: 'zh_TW',
  },
  'ja-JP': {
    translation: jaTrans,
    locale: 'ja',
  },
  'ko-KR': {
    translation: koTrans,
    locale: 'ko',
  },
};

i18next.use(initReactI18next).init({
  // lng: 'en-US',
  fallbackLng: 'en-US',
  // lng: 'zh-CH', // if you're using a language detector, do not define the lng option
  // debug: true,
  resources,
  // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
  // set returnNull to false (and also in the i18next.d.ts options)
  // returnNull: false,
});
